import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "row q-gutter-sm" }
const _hoisted_2 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_s_btn = _resolveComponent("s-btn")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_EntityLink = _resolveComponent("EntityLink")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_ColumnsSettings = _resolveComponent("ColumnsSettings")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_STableSettings = _resolveComponent("STableSettings")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createBlock(_component_q_table, {
    class: _normalizeClass(_ctx.classes),
    "table-class": _ctx.tableClasses,
    dense: "",
    flat: "",
    "binary-state-sort": "",
    columns: _ctx.resultColumns,
    "no-data-label": _ctx.TABLE_SETTINGS.NO_DATA_LABEL,
    "no-results-label": _ctx.TABLE_SETTINGS.NO_RESULTS_LABEL,
    "rows-per-page-options": _ctx.TABLE_SETTINGS.ROWS_PER_PAGE_LIST,
    "rows-per-page-label": _ctx.TABLE_SETTINGS.ROWS_PER_PAGE_LABEL
  }, _createSlots({
    "top-right": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.exportFunc && !_ctx.exportBtnIsHidden)
          ? (_openBlock(), _createBlock(_component_s_btn, {
              key: 0,
              label: "Экспорт",
              class: "s-btn__export",
              icon: "app:download-2",
              loading: _ctx.loading,
              onClick: _ctx.exportTable
            }, null, 8, ["loading", "onClick"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "top-inner-right")
      ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    "body-cell": _withCtx((props) => [
      _createVNode(_component_q_td, {
        props: props,
        class: _normalizeClass({ 's-table--row-deleted': props.row.deletedAt })
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.value), 1)
        ]),
        _: 2
      }, 1032, ["props", "class"])
    ]),
    "header-cell-actions": _withCtx((scope) => [
      _renderSlot(_ctx.$slots, "header-cell-actions", {
        scope: { ...scope, tableSettings: _ctx.tableSettings, hasSavedSettings: _ctx.hasSavedSettings }
      }, () => [
        _createVNode(_component_q_th, { class: "s-table--action_button-wrapper" }, {
          default: _withCtx(() => [
            (_ctx.configurable)
              ? (_openBlock(), _createBlock(_component_STableSettings, {
                  key: 0,
                  highlight: !_ctx.hasSavedSettings
                }, {
                  menu: _withCtx(() => [
                    _createVNode(_component_ColumnsSettings, {
                      modelValue: _ctx.tableSettings,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tableSettings) = $event)),
                      columns: _ctx.columns
                    }, null, 8, ["modelValue", "columns"]),
                    _createVNode(_component_q_separator),
                    (_ctx.isCustomSettings)
                      ? (_openBlock(), _createBlock(_component_q_item, {
                          key: 0,
                          class: "row base-padding"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_s_btn, {
                              class: "full-width text-center",
                              label: "Сбросить настройки",
                              type: "light",
                              icon: "app:delete",
                              onClick: _ctx.resetSettings
                            }, null, 8, ["onClick"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  default: _withCtx(() => [
                    (_ctx.tableSettings.hiddenColumns.length > 0)
                      ? (_openBlock(), _createBlock(_component_q_badge, {
                          key: 0,
                          rounded: "",
                          transparent: "",
                          floating: "",
                          label: _ctx.tableSettings.hiddenColumns.length
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["highlight"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    loading: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (_, i) => {
          return _createVNode(_component_q_skeleton, {
            key: i,
            class: "q-mb-sm",
            type: "rect",
            animation: "fade",
            height: "32px"
          })
        }), 64))
      ])
    ]),
    _: 2
  }, [
    _renderList(_ctx.$slots, (_, name) => {
      return {
        name: name,
        fn: _withCtx((slotData) => [
          _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(slotData)))
        ])
      }
    }),
    _renderList(_ctx.entityLinkColumns, (columnName) => {
      return {
        name: columnName,
        fn: _withCtx((slotData) => [
          _createVNode(_component_q_td, { props: slotData }, {
            default: _withCtx(() => [
              _createVNode(_component_EntityLink, {
                active: _ctx.resolveWithEntity(_ctx.entityLinks[columnName].active, slotData.row),
                deleted: _ctx.resolveWithEntity(_ctx.entityLinks[columnName].deleted, slotData.row),
                location: _ctx.resolveWithEntity(_ctx.entityLinks[columnName].location, slotData.row),
                label: _ctx.resolveWithEntity(_ctx.entityLinks[columnName].label, slotData.row, slotData.value)
              }, null, 8, ["active", "deleted", "location", "label"])
            ]),
            _: 2
          }, 1032, ["props"])
        ])
      }
    })
  ]), 1032, ["class", "table-class", "columns", "no-data-label", "no-results-label", "rows-per-page-options", "rows-per-page-label"]))
}